import React from 'react';
import { tomos } from '../data/constants';
import { Check } from 'lucide-react';
export function ProductOverview() {
  const includes = ['Planificación semanal lista para ejecutar', '40 clases completas con todos los bloques', 'Progresión de carga semana a semana', 'Benchmarks y tests con fichas de registro', 'Progresiones y regresiones por nivel', 'Cues técnicos listos para decir en clase', 'Métodos nuevos explicados para el profe', 'Circuitos, AMRAP, For Time, EMOM listos', '100% aplicable con material estándar'];
  return <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-214">
      <div className="text-center mb-16" data-id="element-215">
        <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-216">
          🏆 COMBO COMPLETO DE E. FUNCIONAL
        </h2>
        <p className="text-xl text-zinc-400 mb-2" data-id="element-217">
          6 Tomos + 6 Bonos — Adaptación → Peak Performance
        </p>
        <p className="text-primary font-bold" data-id="element-218">
          300 páginas — 240 clases completas — Todo resuelto.
        </p>
      </div>

      {/* Tomos Pills */}
      <div className="flex flex-wrap justify-center gap-3 mb-16" data-id="element-219">
        {tomos.map(t => <div key={t.id} className={`px-4 py-2 rounded-full border text-sm font-bold flex items-center gap-2 ${t.color}`} data-id="element-220">
            <span data-id="element-221">{t.id}</span>
            <span className="text-white" data-id="element-222">{t.name.split(' ')[0]}</span>
          </div>)}
      </div>

      <div className="mb-16" data-id="element-223">
        <h3 className="text-2xl font-bold mb-8 text-center flex items-center justify-center gap-2" data-id="element-224">
          <span data-id="element-225">📘</span> 6 TOMOS COMPLETOS
        </h3>
        <p className="text-center text-zinc-400 mb-8" data-id="element-226">
          Sistema Anual Progresivo — Meses 1 a 12
        </p>

        <div className="overflow-x-auto" data-id="element-227">
          <table className="w-full text-left border-collapse" data-id="element-228">
            <thead data-id="element-229">
              <tr className="border-b border-zinc-800 text-zinc-400 text-sm" data-id="element-230">
                <th className="p-4 font-medium" data-id="element-231">Tomo</th>
                <th className="p-4 font-medium" data-id="element-232">Nombre</th>
                <th className="p-4 font-medium" data-id="element-233">Contenido</th>
              </tr>
            </thead>
            <tbody className="text-sm md:text-base" data-id="element-234">
              {tomos.map((t, i) => <tr key={t.id} className={`border-b border-zinc-800/50 ${i % 2 === 0 ? 'bg-surface/30' : ''}`} data-id="element-235">
                  <td className="p-4 font-bold whitespace-nowrap" data-id="element-236">
                    <span className="mr-2" data-id="element-237">{t.icon}</span> Tomo {i + 1}
                  </td>
                  <td className="p-4" data-id="element-238">
                    <div className="font-bold text-white" data-id="element-239">{t.name}</div>
                    <div className="text-xs text-zinc-500" data-id="element-240">{t.months}</div>
                  </td>
                  <td className="p-4 text-zinc-300" data-id="element-241">{t.content}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-surface border border-zinc-800 rounded-2xl p-8" data-id="element-242">
        <h4 className="text-xl font-bold mb-6 text-center" data-id="element-243">
          Cada tomo incluye:
        </h4>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-244">
          {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-245">
              <div className="mt-1 bg-primary/20 p-1 rounded-full" data-id="element-246">
                <Check className="w-3 h-3 text-primary" data-id="element-247" />
              </div>
              <span className="text-zinc-300 text-sm" data-id="element-248">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}